module.exports = __webpack_public_path__ + "img/inside.9c0435f2.jpg";